<template>
  <div id="graderule">
    <!-- 管理员模式 -->
    <div class="yangshi1">
      <div class="header flex-between">
        <div class="header-text">
          <h1>会员等级消费规则设置</h1>
        </div>
        <div class="header-button">
          <el-button v-if="disabled" icon="iconfont icon-chuangjian1" @click="createTable"
            >创建</el-button
          >
          <el-button v-if="disabled" icon="el-icon-edit-outline" plain @click="saveBtn()"
            >保存</el-button
          >
        </div>
      </div>
      <div class="inner" style="width: 100%">
        <el-card>
          <el-row>
            <el-col :span="22">
              <el-form ref="form" :disabled="!disabled" :model="formData" label-width="100px">
                <el-form-item label="订单范围">
                  <el-radio-group
                    v-model="formData.orderRange"
                    style="margin-top: 10px"
                  >
                    <el-row>
                      <el-radio :label="0">从注册时间开始</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio :label="1">从最近一次等级变更开始</el-radio>
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio :label="2">只统计最近一次等级变更后</el-radio>
                      <el-input
                        class="min"
                        :disabled="formData.orderRange == 2 ? false : true"
                        style="width: 65px"
                        v-model="formData.monthLimit1"
                      ></el-input>
                      <span
                        style="
                          width: 100px;
                          display: inline-block;
                          font-size: 14px;
                          margin-left: 3px;
                        "
                        >月的订单</span
                      >
                    </el-row>
                    <el-row style="margin-top: 10px">
                      <el-radio :label="3">只统计最近</el-radio>
                      <el-input
                        class="min"
                        style="width: 65px"
                        :disabled="formData.orderRange == 3 ? false : true"
                        v-model="formData.monthLimit2"
                      ></el-input>
                      <span
                        style="
                          width: 100px;
                          display: inline-block;
                          font-size: 14px;
                          margin-left: 3px;
                        "
                        >月的订单</span
                      >
                    </el-row>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="2">
              <!-- <div style="width:100%;flex-between">
                <el-button
                  class="header-button"
                  icon="el-icon-edit-outline"
                  plain
                  @click="goToOperation"
                  >管理员模式</el-button
                >
              </div> -->
            </el-col>
          </el-row>
        </el-card>
        <!-- 组件 -->
        <consumption
          :radioValue="radioValue"
          :form="form"
          @func="getContent(index)"
          :isDisabled="!disabled"
          ref="formRefs"
        ></consumption>
      </div>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { ruleListApi, ruleInsert } from "@/api/user";
import consumption from "@/components/consumption/index.vue";
export default {
  name: "centre",
  components: {
    consumption,
  },
  data() {
    return {
      comName: [], //子组件
      radioValue: null,
      formData: {
        orderRange: "",
      },
      form: [], //子组件数据
      isDisabled: false,
      disabled:false
    };
  },
  created() {
    this.lookList();
    let GradeRule = JSON.parse(localStorage.getItem("GradeRule"));
    if(GradeRule.length>0){
      this.disabled=true;
    }
  },
  methods: {
    goToOperation() {
      this.$router.push("/Operation");
    },
    // 创建组件
    createTable() {
      this.$refs.formRefs.addLent();
    },
    // 删除组件
    getContent(index) {
      // this.comName.splice(index,1);// 删除对应的子组件
      // console.log(index,0)
      // this.$refs.formRefs[index].deleteList(index + 1);// 删除数据
      this.$refs.formRefs.deleteList(index + 1); // 删除数据
    },
    // 保存
    saveBtn() {
      let flag = true;
      let params = {};
      let from = this.$refs.formRefs.createList();
      for (var i = 0; i < this.$refs.formRefs.$refs.formRefs1.length; i++) {
        this.$refs.formRefs.$refs.formRefs1[i].validate((valid) => {
          if (valid) {
            console.log(i, "成功");
            if (this.formData.orderRange == 2) {
              this.formData.monthLimit = this.formData.monthLimit1;
            } else if (this.formData.orderRange == 3) {
              this.formData.monthLimit = this.formData.monthLimit2;
            } else {
              this.formData.monthLimit = "";
            }
            from.forEach((item) => {
              if (item.onlyMode == 1) {
                item.oneMaxAmt = item.oneMaxAmt1;
              }
              if (item.onlyMode == 2) {
                item.oneMaxAmt = item.oneMaxAmt2;
              }
              if (item.isForbitPhone == false) {
                item.isForbitPhone = 0
              }else item.isForbitPhone = 1
            });
            console.log("from", from,i);
            params = {
              cpyNO: getcpyNo(),
              monthLimit: this.formData.monthLimit,
              orderRange: this.formData.orderRange,
            };
          } else {
            flag = false;
          }
        });
      }
      if (flag) {
        console.log(params,"params")
        // console.log(from,"from")
        ruleInsert(params, from).then((res) => {
          // console.log(res);
          if (res.message == "success") this.lookList();
          return this.$message.success("新增数据成功!");
        });
      }
    },
    // 列表显示
    lookList() {
      ruleListApi().then((res) => {
        // console.log(res,'res');
        if (res.success) {
          res.data.monthLimit2 = "";
          res.data.monthLimit1 = "";
          if (res.data.orderRange == 2) {
            res.data.monthLimit1 = res.data.monthLimit;
          }
          if (res.data.orderRange == 3) {
            res.data.monthLimit2 = res.data.monthLimit;
          }
          if (res.ling.length >= 0) {
            for (let i = 0; i < res.ling.length; i++) {
              res.ling[i].addressType = 1;
              res.ling[i].cardLevelText = res.ling[i].cardLevel;
              this.comName.push({
                name: "consumption",
              });
              if (res.ling[i].onlyMode == 1) {
                res.ling[i].oneMaxAmt1 = "";
                res.ling[i].oneMaxAmt1 = res.ling[i].oneMaxAmt;
              }
              if (res.ling[i].onlyMode == 2) {
                res.ling[i].oneMaxAmt2 = "";
                res.ling[i].oneMaxAmt2 = res.ling[i].oneMaxAmt;
              }
              if (res.ling[i].holdLvlTransTimes == 0) {
                res.ling[i].holdLvlSumAmt1 = "";
                res.ling[i].holdLvlSumAmt1 = res.ling[i].holdLvlSumAmt;
              }
              if (res.ling[i].holdLvlTransTimes == 1) {
                res.ling[i].holdLvlSumAmt2 = "";
                res.ling[i].holdLvlSumAmt2 = res.ling[i].holdLvlSumAmt;
              }
              if(res.ling[i].isForbitPhone==0){
                res.ling[i].isForbitPhone=false
              }else{
                res.ling[i].isForbitPhone=true
              }
              if(res.ling[i].accountLvlID==null) res.ling[i].accountLvlID=""
              // if(res.ling[i].lvlAvailMode==2){
              //   res.ling[i].lvlAvailMonth1=res.ling[i].lvlAvailMonth
              // }
              // if(res.ling[i].lvlAvailMode==3){
              //   res.ling[i].lvlAvailMonth2=res.ling[i].lvlAvailMonth
              // }
            }
          }
          this.formData = res.data;
          // console.log(this.formData);
          this.form = res.ling;
          //  console.log(' this.form ', this.form );
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#graderule {
  height: 100%;
}
.yangshi1 {
  height: 700px;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
/deep/.min .el-input__inner {
  height: 20px;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
}
.el-radio {
  margin: 0;
}
</style>
